import React from 'react';
import BankInfoProvider from './BankInfo.context';
import JobStepHistoryProvider from './JobStepHistory.context';
import UIEvents from './UIEvents.context';
/**
 * Wraps child components with all contexts
 *
 * @param props - children should be passed in
 */
var ContextProvider = function (props) { return (React.createElement(UIEvents, null,
    React.createElement(JobStepHistoryProvider, null,
        React.createElement(BankInfoProvider, null, props.children)))); };
export default ContextProvider;
